import { Panel } from '@wordpress/components'

export const EmptyPost = ({ children }) => (
  <Panel header="Click on Publish to get your score and refresh your browser">
    {children}
  </Panel>
)
